import { Component, OnInit, ViewChild } from '@angular/core';
import { AddCategoryComponent } from './add-category/add-category.component';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MasterService } from '../master.service';
import { LoaderService } from 'src/app/common/loader.service';
import { PartnerTypeModel } from './add-category/partnerType.model';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  addCategory;
  toggleColumn = true;
  categorySearchForm: FormGroup;
  rowData: any[];
  partnerTypes :PartnerTypeModel[];

  newCategory: AddCategoryComponent;
  @ViewChild(AddCategoryComponent, { static: true }) set Content(newCategoryRef) {
    this.newCategory = newCategoryRef;
  }

  constructor(private router: Router, private formBuilder: FormBuilder, private masterService: MasterService,
    private loaderService: LoaderService) {
    this.getFormGroup();
  }

  ngOnInit() {
    this.search();
    this.masterService.getPartnerTypes().subscribe(response => {
      if (response && response['result']) {
        this.partnerTypes = response['result'];
      }
    })
  }

  private getFormGroup() {
    this.categorySearchForm = this.formBuilder.group({
      'id': new FormControl(),
      'partnerType': new FormControl(),
      'code': new FormControl(),
      'descEn': new FormControl(),
      'desc': new FormControl(),
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl(),
    })
  }

  addNewCategory() {
    this.router.navigate(['addCategory']);
    this.newCategory.addCategoryTitle = true;
    this.newCategory.editCategoryTitle = false;
  }

  hideRightDiv() {
    this.addCategory = false;
    this.toggleColumn = true;
  }

  search() {
    let saveData = {};
    saveData["master"] = this.categorySearchForm.value;
    saveData["masterShName"] = "CATEGORY";
    this.loaderService.display(true);
    this.masterService.searchMaster(saveData).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          pName: item.partnerType ? this.partnerTypes.find(obj => obj.partnerTypeId === item.partnerType).partnerTypeName : null
        }))
      }
      if (result) {
        this.rowData = result;
      }

    })
  }

  onRowClicked(event: any) {
    this.addCategory = true;
    this.toggleColumn = false;
    this.newCategory.addCategoryTitle = false;
    this.newCategory.editCategoryTitle = true;
    const searchData = event.data;
    this.newCategory.categoryForm.patchValue({
      id: searchData.id,
      partnerType: searchData.partnerType,
      code: searchData.code,
      descEn: searchData.descEn,
      desc: searchData.desc,
      codeInternational: searchData.codeInternational,
      codeLocal: searchData.codeLocal
    })
  }

  reset() {
    this.categorySearchForm.reset();
  }

}
